import * as React from "react";
// import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Apps from '@material-ui/icons/Apps';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { DashBoard } from "src/component/shared/layout/products/Dashboard";

// tslint:disable-next-line:no-empty-interface
export interface IDashBoardModalProps {}

// tslint:disable-next-line:no-empty-interface
export interface IDashBoardModalState {
  anchorEl?: HTMLElement;
  openModalApps: boolean;
}

export class DashBoardModal extends React.Component<
  IDashBoardModalProps,
  IDashBoardModalState
> {
  constructor(props: IDashBoardModalProps) {
    super(props);

    this.state = {
      anchorEl: undefined,
      openModalApps: false
    };
  }

  public render() {

    return (
      <div>
        <IconButton
          aria-haspopup="true"
          onClick={this.handleClickApps}
          color="inherit"
          aria-label="Menu Apps"
          className="menu-icon-bar">
          <Apps />
        </IconButton>

        <Dialog
              open={this.state.openModalApps}
              onClose={this.handleCloseApps}
              aria-labelledby="economic-group-dialog-title"
              aria-describedby="alereconomic-group-dialog-description"
              className="apps-dialog"
              maxWidth={false}
            >
            <DialogTitle className="apps-dialog-title" id="economic-group-dialog-title">{""}</DialogTitle>
              <DialogContent className="apps-dialog-content">
                <DashBoard />
              </DialogContent>
              <DialogActions className="filter-actions">
                <Button className="filter-dialog-close" onClick={this.handleCloseApps} >
                  Fechar
                </Button>
              </DialogActions>
          </Dialog>

      </div>
    );
  }

  private handleClickApps = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ openModalApps: true });
  };

  private handleCloseApps = () => {
    this.setState({ openModalApps: false });
  };
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/products/DashboardModal.tsx